module.exports = __webpack_public_path__ + "img/money-change.691d65bb.svg";